export default {"src":"/_next/static/media/collect-event-json.880755c2.gif","height":404,"width":568,"blurWidth":0,"blurHeight":0};